import { useAuth } from "../../hooks/use-auth"

export default function Footer() {
    const auth = useAuth();

    return auth?.isAuth()
    ?
    (
        <footer className="sticky-footer bg-white">
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>PediatricAdmin v1.1.20240709</span><br />
                    <span>Developed by Dmitriy Yuriev.</span>
                </div>
            </div>
        </footer>
    )
    :
    (
        <>
        </>
    )
}
